import React from 'react';
import {Skeleton, Tbody} from '@tempo/core';
import ClaimTableRow from './ClaimTableRow';
import Row from '@components/Table/rows/Row';
import Td from '@components/Table/core/Td';
import type {Claim} from '@deezer/next/services/api/Starmania/requests/claim/types';

type ClaimTableBodyProps = {
	data: Claim[];
	onRemove: (claim: Claim) => void;
};

const ClaimTableBody = ({data, onRemove}: ClaimTableBodyProps) => {
	if (data.length === 0) {
		return (
			<Tbody>
				<Row index={0}>
					<Td>
						<Skeleton height="20px" width="100%" />
					</Td>
				</Row>
			</Tbody>
		);
	}

	return (
		<Tbody>
			{data.map((claim, rowIndex) => (
				<ClaimTableRow
					key={rowIndex}
					rowIndex={rowIndex}
					claim={claim}
					onRemove={onRemove}
				/>
			))}
		</Tbody>
	);
};

export default ClaimTableBody;
